import { useQuery } from '@tanstack/react-query';

import { PluginEquifaxConsumerCreditReportFormResponse } from '../../../../types/plugins';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../logic/unwrapNonPaginatedResponseDataAs';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../../constants/pluginBasePath';
import { runEquifaxConsumerCreditReportForm } from '../../requests/runEquifaxConsumerCreditReportForm';

export const useEquifaxConsumerCreditReportForm = (
  applicationUuid: string,
  options?: { enabled?: boolean },
) => {
  const { constructPost } = useRequestConstructor();
  const { data, ...rest } = useQuery<
    | NonPaginatedResponse<PluginEquifaxConsumerCreditReportFormResponse>
    | undefined
  >({
    queryKey: [
      PLUGIN_BASE_PATH,
      'equifax-consumer-credit-report-form',
      applicationUuid,
    ],
    queryFn: () =>
      runEquifaxConsumerCreditReportForm(constructPost, {
        params: { uuid: applicationUuid },
      }),
    enabled: !!applicationUuid,
    ...options,
  });
  return { ...unwrapNonPaginatedResponseDataAs(data, 'formData'), ...rest };
};
